module.exports = __webpack_public_path__ + "static/media/whatsapp.d72d66c4.svg";